import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { MarketApp } from "./market/MarketApp";
import "./styles.css";
import "./market/market.css";

const marketRoute = window.location.pathname === "/market" || window.location.pathname.startsWith("/market/");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {marketRoute ? <MarketApp /> : <App />}
  </StrictMode>,
);
